import { render, staticRenderFns } from "./QrcodeReaderComponent.vue?vue&type=template&id=166820fd&scoped=true&"
import script from "./QrcodeReaderComponent.vue?vue&type=script&lang=js&"
export * from "./QrcodeReaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeReaderComponent.vue?vue&type=style&index=0&id=166820fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166820fd",
  null
  
)

export default component.exports